import { Box } from "@mui/material";

import { useEffect, useState } from "react";

//import PolicyUpdateForm from "./form";
import { AccountsandFinanceurl } from "../../../../config";
import {allDepreciationMethods} from "../../../../data/Columns/Queries/FixedAssetManagement/fixedAssetsmanagement";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { DepreciationMethodsColumns, DepreciationSchedulesColumns,  } from "../../../../data/DynamicTable/Collumns";
import DepreciationMethodsForm from "./form";

const base_url = AccountsandFinanceurl.uri;
const actions = {
  entity: "Depreciation Methods",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "id",
     inputObjectName: "activateDeactivateDepreciationMethod",
     required: "id"
  },

  
  showStatus: true,
};
function DepreciationMethods() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Depreciation Methods"
          subtitle="View all depreciation methods, add and edit"
          columns={DepreciationMethodsColumns}
          FormComponent={DepreciationMethodsForm}
          actions={actions}
          query={allDepreciationMethods}
          base_url={base_url}
        />
      </>
    </Box>
  );
}

export default DepreciationMethods;
